const clampInteger = (value, minimum, maximum, fallback) => {
  const number = Number.parseInt(value, 10);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(Math.max(number, minimum), maximum);
};

export const getVideoGalleryConfig = (homeContent = {}) => ({
  itemsPerSlide: clampInteger(homeContent.video_items_per_slide, 1, 4, 2),
  slideCount: clampInteger(homeContent.video_slide_count, 1, 10, 2),
});

export const buildVideoSlides = (videos = [], homeContent = {}) => {
  const { itemsPerSlide, slideCount } = getVideoGalleryConfig(homeContent);
  const visibleVideos = videos.slice(0, itemsPerSlide * slideCount);
  const slides = Array.from(
    { length: Math.ceil(visibleVideos.length / itemsPerSlide) },
    (_, index) => visibleVideos.slice(index * itemsPerSlide, index * itemsPerSlide + itemsPerSlide),
  );
  return { slides, itemsPerSlide, slideCount };
};

export const videoGridClass = (itemsPerSlide) => {
  if (itemsPerSlide === 1) return "grid-cols-1 mx-auto max-w-3xl";
  if (itemsPerSlide === 3) return "grid-cols-1 md:grid-cols-2 lg:grid-cols-3";
  if (itemsPerSlide === 4) return "grid-cols-1 sm:grid-cols-2 xl:grid-cols-4";
  return "grid-cols-1 md:grid-cols-2";
};
